jQuery(function($) {

    var firstCachedHash = window.location.hash;
    console.log("first hash: " + firstCachedHash);


    var post_page_url = $("#post-page-url").data("url");
    var stylesheet_directory = $("#stylesheet-directory").data("url");
    var site_url = $("#site-url").data("url");


    // Mobile Toggle

    $("#toggle-mobile-menu").on("click", function() {
        // $("#nav-icon2").toggleClass("open");
        $(".mobile-menu").toggleClass("open");
    });
    $(".page-container, .mobile-menu .mobile-close").on("click", function() {
        if($(".mobile-menu").hasClass("open")) {
            $(".mobile-menu").toggleClass("open");
        }
    });




    // Add search value to search field on page load

    if(publicFunctions.param_get("s", window.location.href)) {
        $(".search-field").val(getParameterByName("s", window.location.href));
    }


    // Smooth scroll to anchor
    $(document).on('click', 'a[href^="#"]', function (event) {
        // if menu is open close it on click of anchor link
        if($(".mobile-menu").hasClass("open")) {
            $(".mobile-menu").toggleClass("open");
        }
        // If it's a project run ajax request
        if($(this).prop("href").indexOf("#projects-") != -1) {
            var target_category = $(this).attr("href").replace("#projects-", "");
            $(".btn").removeClass("project-active");
            $(".btn[href='" + window.location.hash + "']").addClass("project-active");
            get_projects_by_category(target_category);
        } else {
            moveToSection($(this).attr("href"));
        }
    });


    // Fix menu on scroll

    $(document).scroll(function(){
        if($(this).scrollTop() >= 5) {
            $("#masthead").addClass("affix");
        } else {
            $("#masthead").removeClass("affix");
        }
    });


    $("#enter-site").on("click", function() {
        $(".a-1").fadeOut().addClass("inactive");
        $(".a-2_services").addClass("active");
        var delay = 1000;
        $(".a-2_service_name").each(function(i) {
            var $this = $(this);
            var allItems = $(".a-2_service_name");
            var prev;
            setTimeout(function() {
                $this.addClass("active");
                prev = i - 1;
                if(i !== 0) {
                    console.log(prev);
                    $(allItems[prev]).find(".design").addClass("inactive");
                }
            }, delay * i);
        });
        setTimeout(function() {
            $(".a-2_awards").addClass("active");
        }, 4000);
        setTimeout(function() {
            $("#homepage_intro").fadeOut();
        }, 6000);
        setTimeout(function() {
            $(".a-3 .page_content, .a-3 .the_posts").fadeIn();
            get_projects_by_category("featured");
            check_thecontent_height();
        }, 7000);
        setTimeout(function() {
            $("body, html").removeClass("intro-active");
            initPage();
        }, 8000);
    });

    $(".get_post").on("click", function() {
        var postID = $(this).data("postid");
        var scrollTo = $(this).data("scrollto");
        var ajaxcontainer = $(this).data("ajaxcontainer");
        get_specific_post(postID, scrollTo, ajaxcontainer);
    });


    // Ajax Projects filter

    function get_projects_by_category(category) {
        var selected_category;
        if(!category) {
            selected_category = window.location.hash.replace("#projects-", "");
        } else {
            selected_category = category;
        }
        console.log(selected_category);
        var post_data = { "action" : "myfilter", "project_category" : selected_category };
        $.ajax({
            url: site_url + "/wp-admin/admin-ajax.php",
            data: post_data, // form data
            type: "post", // POST
            beforeSend:function(xhr){
                $("#projects .all-projects-loader").show();
            },
            success:function(data){
                $("#projects .all-projects-loader").hide();
                $("#inject_projects").html(data);
                initPage();
                setup_project();
                check_rhscontent_width();
                //$.scrollify("update");
                if(selected_category !== "featured") {
                    $.scrollify.move(1);
                }
            }
        });
    }

    // Get Specific Post

    function get_specific_post(postid, scrollto, ajaxcontainer) {
        var specific_post_data = { "action" : "singlepost", "post_id" : postid };
        $("#" + ajaxcontainer).css("height", "100vh");
        $.ajax({
            url: site_url + "/wp-admin/admin-ajax.php",
            data: specific_post_data, // form data
            type: "post", // POST
            beforeSend:function(xhr){
                $(".loader").show();
            },
            success:function(data){
                $(".loader").hide();
                $("#" + ajaxcontainer).html(data);
                $.scrollify("update");
                initPageFunctions();
                var section = $("#" + ajaxcontainer).find(".scrollify-section")
                // moveToSection(section[0].attributes["data-section-name"].value);
                $.scrollify.next();
                section.find(".post-bg").css("background-image", "url(" + section.find(".post-bg").data("background") + ")");
                section.removeClass("scrollified");
                console.log(section[0].attributes["data-section-name"].value);
                if(section.prop("id") == "page-videos") {
                    section.find(".thumb").each(function() {
                        $(this).css("background-image", "url(" + $(this).data("background") + ")");
                    });
                    section.imagesLoaded().done(function() {
                        section.find(".loader").hide();
                    });
                }
                if(section.hasClass("is-news-item")) {
                    section.find(".featured-image img").each(function() {
                        $(this).attr("src", $(this).data("src"))
                    })
                }

                if(section.hasClass("video")) {
                    //console.log("has video class");
                    $(".video-overlay").hide();
                    if(section.hasClass("youtube")) {
                        section.find(".the_video source").attr("src", "");
                    } else {
                    }
                    section.find(".bg").css("background-image", "url(" + section.find(".bg").data("background") + ")");
                }
                section.each(function() {
                    var waypointDown = new Waypoint({
                        element: $(this),
                        handler: function(direction) {
                            if(direction == "down") {
                                //window.location.hash = this.element[0].attributes["data-section-name"].value;
                                if(this.group.last().element[0].attributes["data-section-name"].value == window.location.hash.replace("#","")) {
                                    loadSection(this.next(), direction);
                                    loadSection(this.previous().previous(), direction);
                                } else if(this.group.first().element[0].attributes["data-section-name"].value == window.location.hash.replace("#","")){
                                    loadSection(this.next().next(), direction);
                                } else {
                                    loadSection(this.next().next(), direction);
                                    loadSection(this)
                                }
                            }
                        },
                        continuous: false
                    })
                    var waypointUp = new Waypoint({
                        element: $(this),
                        handler: function(direction) {
                            if(direction == "up") {
                                //window.location.hash = this.previous().element[0].attributes["data-section-name"].value;
                                if(this.group.last().element[0].attributes["data-section-name"].value == window.location.hash.replace("#","")) {
                                    loadSection(this, direction);
                                } else if(this.group.first().element[0].attributes["data-section-name"].value == window.location.hash.replace("#","")){
                                    loadSection(this.next(), direction);
                                } else {
                                    loadSection(this.previous().previous(), direction);
                                    loadSection(this)
                                }
                            }
                        },
                        continuous: false,
                        offset: "-50%"
                    })
                });
                Waypoint.refreshAll()
            }
        });
    }

    function moveToSection(sectionName) {
        // $('html, body').animate({
        //     scrollTop: $(".scrollify-section[data-section-name='" + sectionName + "']").offset().top
        // }, 1000);
        console.log(sectionName);
        $.scrollify.move(sectionName);
    }

    function loadSection(section, direction) {
        var current = section.element;
        var actualCurrent;
        if(direction == "up") {
            if( section.element[0].id == "page-contact") {
                actualCurrent = section.element;
            } else {
                actualCurrent = section.next().element;
            }
        } else {
            actualCurrent = section.previous().element
        }
        current.removeClass("content-hidden");
        actualCurrent.removeClass("scrollified");
        if(current.prop("id") == "page-videos") {
            current.find(".thumb").each(function() {
                $(this).css("background-image", "url(" + $(this).data("background") + ")");
            });
            current.imagesLoaded( { background: '.image' }, function() {
                current.find(".loader").hide();
            });
        }
        if(current.prop("id") == "page-press-archive") {
            current.find(".press-image img").each(function() {
                $(this).attr("src", $(this).data("src"));
            });
            current.imagesLoaded().done(function() {
                current.find(".loader").hide();
            });
        }
        if(current.prop("id") == "page-awards") {
            current.find(".awards-image img").each(function() {
                $(this).attr("src", $(this).data("src"));
            });
            current.imagesLoaded().done(function() {
                current.find(".loader").hide();
            });
        }
        if(current.prop("id") == "page-exhibitions-lectures") {
            current.find(".lectures-exhibitions-image img").each(function() {
                $(this).attr("src", $(this).data("src"));
            });
            current.imagesLoaded().done(function() {
                current.find(".loader").hide();
            });
        }
        if(current.prop("id") == "page-books") {
            current.find(".book-item img").each(function() {
                $(this).attr("src", $(this).data("src"));
            });
            current.imagesLoaded().done(function() {
                current.find(".loader").hide();
            });
        }
        if(current.prop("id") == "page-news") {
            current.find(".thumb").each(function() {
                $(this).css("background-image", "url(" + $(this).data("background") + ")");
            });
            current.imagesLoaded().done(function() {
                current.find(".loader").hide();
            });
        }
        if(current.prop("id") == "page-videos") {
            current.find(".thumb").each(function() {
                $(this).css("background-image", "url(" + $(this).data("background") + ")");
            });
            current.imagesLoaded().done(function() {
                current.find(".loader").hide();
            });
        }
        if(current.hasClass("is-news-item")) {
            current.find(".featured-image img").each(function() {
                $(this).attr("src", $(this).data("src"))
            })
        }
        if(current.hasClass("video")) {
            //console.log("has video class");
            //$(".video-overlay").hide();
            if(current.hasClass("youtube")) {
                current.find(".the_video source").attr("src", "");
            } else {
            }
            current.find(".bg").css("background-image", "url(" + current.find(".bg").data("background") + ")");
        }
        if(current.prop("id") == "page-timeline") {
            calculateTimelineWidths();
            fixTimelineContainerWidth();
            current.find(".thumb").each(function() {
                //console.log($(this).data("src"));
                $(this).attr("src", $(this).data("src"));
            });
            current.imagesLoaded().done(function() {
                current.find(".loader").hide();
            });
        }
        if(current.hasClass("project")) {
            current.find(".image").each(function() {
                if($(window).width() < 767) {
                    $(this).css("background-image", "url(" + $(this).data("mobile-background") + ")");
                } else {
                    $(this).css("background-image", "url(" + $(this).data("background") + ")");
                }
            });
            current.imagesLoaded( { background: '.image' }, function() {
                current.find(".loader").hide();
            });
            var nextSibling = current[0].nextElementSibling;
            if($(window).width() <= 1024 && $(window).width() > 576) {
                $(nextSibling).find(".image").each(function() {
                    $(this).css("background-image", "url(" + $(this).data("background") + ")");
                });
                $(nextSibling).find(".loader").hide();
                $(nextSibling).removeClass("scrollified");
            }
        } else if(current.hasClass("content-leftsidebar")) {
            var background_image = current.find(".post-bg").data("background");
            var portrait_image = current.find(".post-bg .portrait").data("background");
            var mobile_background_image = current.find(".post-bg").data("mobile-background");
            var mobile_portrait_image = current.find(".post-bg .portrait").data("mobile-background");
            var nextSiblingContentLeft = current[0].nextElementSibling;

            if($(window).width() < 767) {
                current.find(".post-bg").css("background-image", "url('" + mobile_background_image + "')");
                current.find(".post-bg .portrait").css("background-image", "url('" + mobile_portrait_image + "')");

            } else {
                current.find(".post-bg").css("background-image", "url('" + background_image + "')");
                current.find(".post-bg .portrait").css("background-image", "url('" + portrait_image + "')");

            }
            if($(nextSiblingContentLeft).prop("id") == "page-about-paul-mcaneary") {
                $(nextSiblingContentLeft).find(".post-bg").each(function() {
                    $(this).css("background-image", "url(" + $(this).data("background") + ")");
                });
                $(nextSiblingContentLeft).find(".loader").hide();
                $(nextSiblingContentLeft).removeClass("scrollified");
            }
        } else {
            var background_image2 = current.find(".post-bg .image").data("background");
            current.find(".post-bg .image").css("background-image", "url(" + background_image2 + ")");

        }
    }

    function initPage() {

        console.log("section-init");

        if(!$("body").hasClass("single")) {
            check_rhscontent_width();
            $.scrollify({
                section : ".scrollify-section",
                interstitialSection : "",
                easing: "easeOutExpo",
                scrollSpeed: 1800,
                offset : 0,
                scrollbars: true,
                standardScrollElements: ".the_content, .mobile-menu, #contact-form .the_form, .recruitments-content",
                setHeights: false,
                overflowScroll: false,
                updateHash: true,
                touchScroll: true,
                before:function() {
                    $.scrollify.current().find(".bg").css("background-image", "url(" + $.scrollify.current().find(".bg").data("background") + ")");
                    $(".video-overlay").hide();
                    $(".the_video").attr("src", "")
                },
                after:function() {
                    $("#masthead").fadeIn();
                    },
                    afterResize:function() {
                        $.scrollify.move("#" + $.scrollify.current()[0].attributes["data-section-name"].value);
                    },
                    afterRender:function() {}
                });


            var waypoints = [];

            // // Setup isScrolling variable
            // var isScrolling;
            //
            // // Listen for scroll events
            // window.addEventListener('scroll', function ( event ) {
            //
            // 	// Clear our timeout throughout the scroll
            // 	window.clearTimeout( isScrolling );
            //
            // 	// Set a timeout to run after scrolling ends
            // 	isScrolling = setTimeout(function() {
            //
            // 		// Run the callback
            // 		$.scrollify.move(window.location.hash);
            //
            // 	}, 1200);
            //
            // }, false);

            $(".scrollify-section").each(function() {
                var waypointDown = new Waypoint({
                    element: $(this),
                    handler: function(direction) {
                        if(direction == "down") {
                            window.location.hash = this.element[0].attributes["data-section-name"].value;
                            if(this.group.last().element[0].attributes["data-section-name"].value == window.location.hash.replace("#","")) {
                                loadSection(this.next(), direction);
                                loadSection(this.previous().previous(), direction);
                            } else if(this.group.first().element[0].attributes["data-section-name"].value == window.location.hash.replace("#","")){
                                loadSection(this.next().next(), direction);
                            } else {
                                loadSection(this.next().next(), direction);
                                loadSection(this)
                            }
                        }
                    },
                    continuous: false
                })
                var waypointUp = new Waypoint({
                    element: $(this),
                    handler: function(direction) {
                        if(direction == "up") {
                            window.location.hash = this.previous().element[0].attributes["data-section-name"].value;
                            if(this.group.last().element[0].attributes["data-section-name"].value == window.location.hash.replace("#","")) {
                                loadSection(this, direction);
                            } else if(this.group.first().element[0].attributes["data-section-name"].value == window.location.hash.replace("#","")){
                                loadSection(this.next(), direction);
                            } else {
                                loadSection(this.previous().previous(), direction);
                                loadSection(this)
                            }
                        }
                    },
                    continuous: false,
                    offset: "-50%"
                })
            });

        }
        //moveToSection(firstCachedHash.replace("#",""));
        check_rhscontent_width();

        // Move to next Section

        // $(".scrollify-down-1").on("click", function() {
        //     $.scrollify.next();
        // });

        // The content scroll prevent parent from scrolling too

        $( '.the_content, .mobile-menu, #contact-form .the_form, .recruitments-content' ).on( 'mousewheel DOMMouseScroll touchleave', function ( e ) {
            var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;

            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });
        // $('.the_content, .mobile-menu, #contact-form .the_form, .recruitments-content').on('DOMMouseScroll mousewheel', function(ev) {
        //     var $this = $(this),
        //         scrollTop = this.scrollTop,
        //         scrollHeight = this.scrollHeight,
        //         height = $this.height(),
        //         delta = (ev.type == 'DOMMouseScroll' ?
        //             ev.originalEvent.detail * -40 :
        //             ev.originalEvent.wheelDelta),
        //         up = delta > 0;
        //
        //     var prevent = function() {
        //         ev.stopPropagation();
        //         ev.preventDefault();
        //         ev.returnValue = false;
        //         return false;
        //     }
        //
        //     if (!up && -delta > scrollHeight - height - scrollTop) {
        //         // Scrolling down, but this will take us past the bottom.
        //         $this.scrollTop(scrollHeight);
        //         return prevent();
        //     } else if (up && delta > scrollTop) {
        //         // Scrolling up, but this will take us past the top.
        //         $this.scrollTop(0);
        //         return prevent();
        //     }
        // });




        // Slide content box projects

        $(".the_posts .project").on( 'click', ".next-content", function() {
            var nextLink = $(this);
            var parent = nextLink.parent().parent().parent();
            var width = parent.find(".post-bg .image").outerWidth();
            parent.addClass("content-hidden");
            if((parent.find(".post-bg").scrollLeft() + width) >= (parent.find(".post-bg")[0].scrollWidth - width)) {
                nextLink.hide();
            } else {
                parent.find(".less-content").show();
            }
            scrollDiv(nextLink, width);
        });

        // Slide content box to left projects

        $(".the_posts .project").on( 'click', ".less-content", function() {
            var prevLink = $(this);
            var parent = prevLink.parent().parent().parent();
            var width = parent.find(".post-bg .image").outerWidth();
            parent.find(".next-content").show()
            if(parent.find(".post-bg").scrollLeft() == width) {
                prevLink.hide();
            } else {
                parent.find(".next-content").show();
            }
            scrollDivLeft(prevLink, width);
        });

        // Scroll lhs content down

        $(".the_posts .content").on( 'click', '.show-more', function () {
            $(this).parent().find(".the_content").animate({
                scrollTop: "+=160"
            }, 300);
        });

        // Close lhs content

        $(".the_posts .post").on( 'click', '.close-content', function () {
            $(this).parent().parent().parent().addClass("content-hidden");
        });

        // Open lhs content

        $(".the_posts .post").on( 'click', '.open-content', function () {
            $(this).parent().parent().parent().removeClass("content-hidden");
        });

        // Open lhs content - mobile

        $(".the_posts .post").on("click", ".mobile-title .text", function() {
            $(this).parent().parent().parent().parent().addClass("content-visible");
            $("body").addClass("no-scroll");
            $("#toggle-mobile-menu").addClass("d-none");
        });

        // Open content on mobile

        $(".the_posts .post").on("click", ".open-content-mobile", function() {
            $(this).parent().parent().parent().addClass("content-visible");
            $("body").addClass("no-scroll");
            $("#toggle-mobile-menu").addClass("d-none");
        });

        // Close content on mobile

        $(".the_posts .post").on("click", ".mobile-close", function() {
            $(this).parent().parent().removeClass("content-visible");
            $("body").removeClass("no-scroll");
            $("#toggle-mobile-menu").removeClass("d-none");
            //$.scrollify.enable();
        });


        // $(".next-content, .less-content").hover(function() {
        //     $.scrollify.disable();
        // })
        //
        // $(".next-content, .less-content").mouseleave(function() {
        //     $.scrollify.enable();
        //     $.scrollify.update();
        //     $.scrollify.move("#" + $.scrollify.current()[0].attributes["data-section-name"].value);
        // })
    }


    function initPageFunctions() {

        // Videos

        // $(".video .play-button").each(function() {
        //     var videoPlayer = $("#" + $(this).data("playerid"));
        //     var iframe = $(this).parent().find(".the_video");
        //     var overlay = $(this).parent().find(".video-overlay");
        //     videoPlayer = new Vimeo.Player(videoPlayer);
        //     $(this).on("click", function() {
        //         overlay.fadeIn();
        //         videoPlayer.play();
        //     });
        //     videoPlayer.on('pause', function() {
        //         overlay.fadeOut();
        //     });
        // });

        // function toggleVideo(state, videoPlayer) {
        //     // if state == 'hide', hide. Else: show video
        //     var div = document.getElementById("popupVid");
        //     var iframe = videoPlayer;
        //     div.style.display = state == 'hide' ? 'none' : '';
        //     func = state == 'hide' ? 'pauseVideo' : 'playVideo';
        //     iframe.postMessage('{"event":"command","func":"' + func + '","args":""}','*');
        // }
        //
        // $(".video .play-button").each(function() {
        //     var videoPlayer = $("#" + $(this).data("playerid"));
        //     var iframe = $(this).parent().find(".the_video");
        //     var overlay = $(this).parent().find(".video-overlay");
        //     // window.onYouTubeIframeAPIReady = function() {
        //     //     videoPlayer = new YT.Player("#video-384");
        //     // }
        //     // console.log(videoPlayer);
        //     $(this).on("click", function() {
        //         overlay.fadeIn();
        //         videoPlayer.attr("src", videoPlayer.data("src") + "&autoplay=1")
        //     });
        //     videoPlayer.on('click', function() {
        //         console.log("test")
        //         overlay.fadeOut();
        //         videoPlayer.attr("src", "");
        //     });
        // });



        console.log("init page activated");

        // Open mobile content on click of title

        $(".page .mobile-content .the_title").each(function() {
            $(this).on("click", function() {
                if($(this).parent().parent().parent().parent().find(".content .the_content").children().length > 0) {
                    //$.scrollify.disable();
                    $("body").addClass("no-scroll");
                    $(this).parent().parent().parent().parent().addClass("content-visible");
                }
            });
        });



        // Videos

        $(".video .play-button").each(function() {
            console.log("this");
            var parent = $(this).parent();
            $(this).on("click", function() {
                console.log(parent.find(".the_video")[0]);
                parent.find(".video-overlay").fadeIn();
                $("#masthead").fadeOut();
                if(parent.parent().hasClass("youtube")) {
                    parent.find(".the_video").attr("src", parent.find(".the_video").data("src") + "&autoplay=1");
                } else {
                    var videoUrl = parent.find(".the_video source").data("src");
                    parent.find(".the_video source").attr("src", videoUrl)
                    parent.find(".the_video")[0].play();
                }
            });
        });

        // $(".play-button").on("click", function() {
        //     var videoUrl = $(this).parent().find(".the_video source").data("src");
        //     $(this).parent().find(".the_video source").attr("src", videoUrl)
        // });

        // Page Controls



        $("#toggleMap").on("click", function() {
            $("#toggleMap, #contact-form").removeClass("active");
            $("#map, #toggleForm").addClass("active");
            // if($(window).width() < 767) {
            //     $("#masthead").hide();
            // }
        });
        $("#toggleForm").on("click", function() {
            $("#toggleForm, #map").removeClass("active");
            $("#contact-form, #toggleMap").addClass("active");
            // if($(window).width() < 767) {
            //     $("#masthead").hide();
            // }
        });
        $("#contact-form .mobile-close, #map .mobile-close").on("click", function() {
            $("#contact-form, #map").removeClass("active");
        });

    }
    initPageFunctions();

    // Slide content box along on pages

    $(".pages .content-leftsidebar").on( 'click', ".next-content", function() {
        var nextLink = $(this);
        var parent = nextLink.parent().parent().parent();
        var width = parent.find(".post-bg").outerWidth();
        var scrollAmountNext = parent.find(".column").outerWidth();
        parent.addClass("content-hidden");
        var innerContentWidth = 0;
        parent.find(".column").each(function() {
            innerContentWidth += $(this).outerWidth();
        })
        if(parent.find(".post-bg").scrollLeft() > innerContentWidth + (scrollAmountNext * 2) + (parent.find(".content").outerWidth() + 60)) {
        //if(parent.find(".rhs-content").outerWidth() >= parent.find(".post-bg")[0].scrollWidth) {
            $(this).hide();
            //console.log("is at end");
            scrollDiv(nextLink, scrollAmountNext);
        } else {
            scrollDiv(nextLink, scrollAmountNext);
        }
    });
    $(".pages .content-leftsidebar").on( 'click', ".less-content", function() {
        var nextLink = $(this);
        var scrollAmount = $(window).outerWidth() / 2;
        var parent = nextLink.parent().parent().parent();
        var scrollAmountPrev = parent.find(".column").outerWidth();

        console.log(parent.find(".post-bg").scrollLeft());
        console.log(parent.find(".post-bg").scrollLeft());
        if((parent.find(".post-bg").scrollLeft() - scrollAmountPrev) * 2 < scrollAmountPrev) {
            parent.removeClass("content-hidden");
            parent.find(".next-content").show();
            scrollDivLeft(nextLink, 1000);
        } else {
            scrollDivLeft(nextLink, scrollAmountPrev);
        }
    });

    // Timeline functions

    $("#page-timeline").on( 'click', ".timeline-rhs", function() {
        var scrollAmount;
        if($(window).width() > 576) {
            scrollAmount = "+=1000";
        } else {
            scrollAmount = "+=150";
        }
        var timeline = $(".timeline-container");
        timeline.animate({
            scrollLeft: scrollAmount
        }, 500);
    });
    $("#page-timeline").on( 'click', ".timeline-lhs", function() {
        var scrollAmount;
        if($(window).width() > 576) {
            scrollAmount = "-=1000";
        } else {
            scrollAmount = "-=150";
        }
        var timeline = $(".timeline-container");
        timeline.animate({
            scrollLeft: scrollAmount
        }, 500);
    });

    // Show post show more button if content overflows, else hide

    function check_thecontent_height() {
        $(".post .the_content").each(function() {
            if ($(this)[0].offsetHeight < $(this)[0].scrollHeight) {
                $(this).parent().find(".show-more").show();
            }
        });
    }

    function check_rhscontent_width() {
        $(".content-leftsidebar .rhs-content").each(function() {
            //console.log($(this)[0]);
            var rhsContentWidth = $(this).width();
            var postBgWidth = $(this).parent()[0].scrollWidth;
            var contentWidth = $(this).parent().parent().find(".content").outerWidth();
            var contentPadding = parseInt($(this).parent().parent().find(".content").css("padding-right").replace("px", "")) * 2;
            if((rhsContentWidth > postBgWidth) - (contentWidth + contentPadding)) {
                $(this).parent().parent().find(".rhs").show();
            }
        });
    }


    function setup_project() {
        check_thecontent_height();
        $(".post-bg").each(function() {
            var images = $(this).find(".image");
            //nextFadeIn(images);
        });
    }

    // Slide post BG along

    function scrollDiv(element, widthToScroll) {
        var width = "+=" + widthToScroll;
        element.parent().parent().parent().find(".post-bg").animate({
            scrollLeft: width
        }, 500);
    }
    function scrollDivLeft(element, widthToScroll) {
        var width = "-=" + widthToScroll;
        element.parent().parent().parent().find(".post-bg").animate({
            scrollLeft: width
        }, 500);
    }

    // If Is single

    if($("body").hasClass("single")) {
        initPage();
    }

    // Rotate through images

    $next = 1;
	$current = 0;
	$interval = 4000;
	$fadeTime = 800;
	$imgNum = 5;

    // $(".post-bg").each(function() {
    //     var images = $(this).find(".image");
    //     nextFadeIn(images);
    // });

	function nextFadeIn(project) {
        var images = project; // image selector
        var interval = 4000;           // milliseconds between transitions
        var index = 0;                // starting index
        var count = images.length;  // image count
          // the transition loop
        var handle = setInterval(function() {
            // fade out the current image
                $(images[index]).fadeOut(1000);
                // get the next index, or cycle back to 0
                if (++index === count) index = 0;
                // fade in the next image
                $(images[index]).fadeIn(1000);
            }, interval);
        var stop = function() {
            clearInterval(handle);
        };
	}

    // Vegas controls

    $(".vegas-wrapper .next-vegas-photo").on("click", function() {
        $(".lhs").fadeIn();
        $(".the_posts").vegas('next');
    });

    $(".vegas-wrapper .prev-vegas-photo").on("click", function() {
        console.log($(".the_posts").vegas()[0]._vegas.slide);
        if($(".the_posts").vegas()[0]._vegas.slide == 0) {
            $(".lhs").fadeOut();
            //$("#single .content").removeClass("content-hidden");
        } else {
            $(".the_posts").vegas('previous');
        }
    });


    // Page organizing

    function changeTeamColumnSize() {
        var teamlistItems = $(".teamlist li");
        var length = 16;
        if($(window).width() < 787 && $(window).width() > 576) {
            length = 35;
        } else if($(window).width() < 576) {
            length = 15;
        }
        teamlistItems.detach().appendTo(".teamlist");
        $(".teamlist .column").remove();
        for(var i = 0; i < teamlistItems.length; i+=length) {
            teamlistItems.slice(i, i+length).wrapAll("<div class='column'></div>");
        }
    }
    changeTeamColumnSize();

    function changeAwardsColumnSize() {
        var awardsItems = $(".awards .award");
        var length = 3;
        if($(window).width() < 787 && $(window).width() > 576) {
            length = 6;
        } else if($(window).width() < 576) {
            length = 3;
        }
        awardsItems.detach().appendTo(".awards");
        $(".awards .column").remove();
        for(var i = 0; i < awardsItems.length; i+=length) {
            awardsItems.slice(i, i+length).wrapAll("<div class='column'></div>");
        }
    }
    changeAwardsColumnSize();

    function changeBooksColumnSize() {
        var bookItems = $(".book-items .book-item");
        var length = 1;
        if($(window).width() < 787 && $(window).width() > 576) {
            length = 2;
        } else if($(window).width() < 576) {
            length = 1;
        }
        bookItems.detach().appendTo(".book-items");
        $(".book-items .column").remove();
        for(var i = 0; i < bookItems.length; i+=length) {
            bookItems.slice(i, i+length).wrapAll("<div class='column'></div>");
        }
    }
    changeBooksColumnSize();

    $(".gform_footer").detach().appendTo(".gform_fields");
    function fixFormOnMobile() {
        if($(window).width() < 767) {
            $("#page-contact .rhs-content .contact").detach().appendTo("#page-contact .mobile-form-holder");
        } else {
            $("#page-contact .rhs-content .contact").detach().appendTo("#page-contact .rhs-content");
        }
    }
    fixFormOnMobile();


    function contactFormVisibility() {
        $("#map").removeClass("active");
        if($(window).width() < 576) {
            $("#contact-form").removeClass("active");
        } else {
            $("#contact-form").addClass("active");
        }
    }
    contactFormVisibility();

    function changeLecturesExhibitionsColumnSize() {
        var lectureItems = $(".lectures-exhibitions .lectures-exhibition[data-parent='lecture']");
        var exhibitionItems = $(".lectures-exhibitions .lectures-exhibition[data-parent='exhibition']");
        var length = 4;
        if($(window).width() < 787 && $(window).width() > 576) {
            length = 5;
        } else if($(window).width() < 576) {
            length = 4;
        }
        lectureItems.detach().appendTo(".lecture");
        exhibitionItems.detach().appendTo(".lecture");
        $(".column-lecture, .column-exhibition").remove();
        for(var i = 0; i < lectureItems.length; i+=length) {
            lectureItems.slice(i, i+length).wrapAll("<div class='column column-lecture'></div>");
        }
        for(var m = 0; m < exhibitionItems.length; m+=length) {
            exhibitionItems.slice(m, m+length).wrapAll("<div class='column column-exhibition'></div>");
        }
        $(".column-lecture").detach().appendTo(".lecture");
        $(".column-exhibition").detach().appendTo(".exhibition");
    }
    changeLecturesExhibitionsColumnSize();

    function changePressColumnSize() {
        var pressItems = $(".press .press-item");
        var length = 3;
        if($(window).width() < 787 && $(window).width() > 576) {
            length = 10;
        } else if($(window).width() < 576) {
            length = 3;
        }
        pressItems.detach().appendTo(".press");
        $(".press .column").remove();
        for(var i = 0; i < pressItems.length; i+=length) {
            pressItems.slice(i, i+length).wrapAll("<div class='column'></div>");
        }
    }
    changePressColumnSize();

    function changeVideosColumnSize() {
        var videoItems = $(".video-items .video-item");
        var length = 1;
        if($(window).width() < 787 && $(window).width() > 576) {
            length = 3;
        } else if($(window).width() < 576) {
            length = 3;
        }
        videoItems.detach().appendTo(".video-items");
        $(".video-items .column").remove();
        for(var i = 0; i < videoItems.length; i+=length) {
            videoItems.slice(i, i+length).wrapAll("<div class='column'></div>");
        }
    }
    changeVideosColumnSize();

    function calculateTimelineWidths() {
        $(".timeline-year:not(.small-year)").each(function() {
            var topEntries = $(this).find(".entries-top").outerWidth();
            var bottomEntries = $(this).find(".entries-bottom").outerWidth();
            var largestChild = Math.max(topEntries, bottomEntries);
            $(this).width(largestChild + 30);
        })
    }
    calculateTimelineWidths();

    $(window).resize(function() {
        changeTeamColumnSize();
        changeAwardsColumnSize();
        changeBooksColumnSize();
        changeLecturesExhibitionsColumnSize();
        changePressColumnSize();
        changeVideosColumnSize();
        contactFormVisibility();
        fixFormOnMobile();
        //resizeSafariWindows();
    });

    function fixTimelineContainerWidth() {
        var timelineYearWidths = 0;
        $(".timeline .timeline-year").each(function() {
            console.log($(this).outerWidth())
            timelineYearWidths += $(this).width();
        })
        $(".timeline").width(timelineYearWidths)
    }
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    if(isAndroid) {
        $("body").addClass("android");
    }
    function resizeSafariWindows() {
        if($(window).width() < 767) {
            var windowHeight = window.innerHeight;
            $(".scrollify-section, .post-bg").height(windowHeight);
        }
    }

    if($("body").hasClass("safari") )  {
        //resizeSafariWindows()
    }

    // $('html, body').on('touchstart touchmove', function(e){
    //     $("body").css("overflow", "hidden");
    // });


    if(window.location.hash) {
        $("body").addClass("hide-intro");
        $("body, html").removeClass("intro-active");
        //initPage();
        if(window.location.hash.indexOf("projects-") != -1) {
            $("body").removeClass("intro-active");
            $(".btn[href='" + window.location.hash + "']").addClass("project-active");
            get_projects_by_category();
        } else {
            get_projects_by_category("featured");
        }
    }

});
